const CSV_COLUMNS = [
    'ruleGroupId',
    'isEnabled',
    'originalExternalSku',
    'originalName',
    'originalOnHandUnits',
    'originalSlotNumber',
    'originalSlotStatus',
    'originalOnOrderQuantity',
    'substituteExternalSku',
    'substituteName',
    'substituteQuantity',
    'substituteOnHandUnits',
    'substituteSlotNumber',
    'substituteSlotStatus',
    'substituteOnOrderQuantity',
];

/**
 * Escapes a value for CSV (quotes when needed).
 * @param {unknown} value
 * @returns {string}
 */
export function escapeCsvValue(value) {
    if (value === null || value === undefined) {
        return '';
    }
    const stringValue = String(value);
    if (/[",\n\r]/.test(stringValue)) {
        return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
}

/**
 * Flattens substitution rules (one CSV row per substitute) and builds CSV text.
 * Rules with an empty substitutionRuleQuantitySet still emit one row with blank substitute columns.
 *
 * @param {Array<Object>} rules
 * @returns {string}
 */
export function buildSubstitutionRulesCsv(rules) {
    const rows = Array.isArray(rules) ? rules : [];
    const lines = [CSV_COLUMNS.join(',')];

    rows.forEach((rule) => {
        const substitutes = Array.isArray(rule?.substitutionRuleQuantitySet) ? rule.substitutionRuleQuantitySet : [];
        const substituteRows = substitutes.length > 0 ? substitutes : [{}];

        substituteRows.forEach((substitute) => {
            const values = CSV_COLUMNS.map((column) => {
                if (column.startsWith('substitute')) {
                    return escapeCsvValue(substitute?.[column]);
                }
                return escapeCsvValue(rule?.[column]);
            });
            lines.push(values.join(','));
        });
    });

    return `${lines.join('\n')}\n`;
}

export { CSV_COLUMNS };
